import React, {Component} from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import PageLayout from '../modules/PageLayout'
import NotFound from '../modules/NotFound'

class Page extends Component {
  render () {
    if (!this.props.title) return <NotFound/>

    return (
      <PageLayout
        title={this.props.title}
        image={this.props.image}
        video={this.props.video}
        sections={this.props.sections}
      />
    )
  }
}

export default withRouter(connect(
 (state, props) => ({
   ...state.rist.content.pages.find(p => p.url == '/'+props.match.params.slug),
 })
)(Page))



// WEBPACK FOOTER //
// ./src/Rist/containers/Page.js